import { render } from "./SuccessfulResetPassword.vue?vue&type=template&id=82af9cc4&scoped=true"
import script from "./SuccessfulResetPassword.vue?vue&type=script&lang=js"
export * from "./SuccessfulResetPassword.vue?vue&type=script&lang=js"

import "./SuccessfulResetPassword.vue?vue&type=style&index=0&id=82af9cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82af9cc4"]])

export default __exports__